import { useEffect } from 'react';
import { useSpring } from 'framer-motion';

/** Subtle depth parallax: follows the pointer (or touch) by up to `strength` px. */
export function usePointerParallax(strength: number) {
  const x = useSpring(0, { stiffness: 60, damping: 20 });
  const y = useSpring(0, { stiffness: 60, damping: 20 });

  useEffect(() => {
    if (!strength) {
      x.set(0);
      y.set(0);
      return;
    }
    const onMove = (e: PointerEvent) => {
      x.set((e.clientX / window.innerWidth - 0.5) * 2 * strength);
      y.set((e.clientY / window.innerHeight - 0.5) * 2 * strength);
    };
    window.addEventListener('pointermove', onMove, { passive: true });
    return () => window.removeEventListener('pointermove', onMove);
  }, [strength, x, y]);

  return { x, y };
}
